<div class="content" role="main">
    <div class="card-container">
        <mat-card class="app-card">
          <mat-card-header>
            <div mat-card-avatar class="app-card-header-image"></div>
            <mat-card-title>Tamil Stickers</mat-card-title>
            <mat-card-subtitle>WAStickerApps, WAStatus saver</mat-card-subtitle>
          </mat-card-header>
          <img mat-card-image src="https://lh3.googleusercontent.com/VfFt5aCbcRvtS206QjkeFo-17dG4HB72aHaYv8oe-ajzLt2qYP-TUKejcprAKfmvW3M=s180-rw" alt="Photo of a Shiba Inu">
          <mat-card-content>
            <p>
              Do you like show your emotions better than simple text? <br><br>
              WhatsApp stickers is the best way to express your emotions with fun.<br>
              The Best and Fun WhatsApp stickers are here.!!! <br><br>
              Send them to your friends and family and have fun.!!
            </p>
          </mat-card-content>
          <mat-card-actions>
            <a href="https://play.google.com/store/apps/details?id=com.tamil.stickstat&hl=en_IN">
              <img id="comp-jnsvmi4dimgimage" style="object-position:50% 50%;width:170px;height:49px;object-fit:cover"
             alt="" data-type="image" itemprop="image" 
             src="https://static.wixstatic.com/media/c22c23_c42aa7dcdc3d4e378a967019f512a6ca~mv2.png/v1/fill/w_170,h_49,al_c,q_85,usm_0.66_1.00_0.01/PlayStore-BTN_02.webp">
             </a>
          </mat-card-actions>
        </mat-card>
        <!-- <mat-card class="app-card">
          <mat-card-header>
            <div mat-card-avatar class="app-card-header-image"></div>
            <mat-card-title>Tamil Stickers</mat-card-title>
            <mat-card-subtitle>WAStickerApps, WAStatus saver</mat-card-subtitle>
          </mat-card-header>
          <img mat-card-image src="https://lh3.googleusercontent.com/VfFt5aCbcRvtS206QjkeFo-17dG4HB72aHaYv8oe-ajzLt2qYP-TUKejcprAKfmvW3M=s180-rw" alt="Photo of a Shiba Inu">
          <mat-card-content>
            <p>
              Do you like show your emotions better than simple text? <br><br>
              WhatsApp stickers is the best way to express your emotions with fun.<br>
              The Best and Fun WhatsApp stickers are here.!!! <br><br>
              Send them to your friends and family and have fun.!!
            </p>
          </mat-card-content>
          <mat-card-actions>
            <a href="https://play.google.com/store/apps/details?id=com.tamil.stickstat&hl=en_IN">
              <img id="comp-jnsvmi4dimgimage" style="object-position:50% 50%;width:170px;height:49px;object-fit:cover"
             alt="" data-type="image" itemprop="image" 
             src="https://static.wixstatic.com/media/c22c23_c42aa7dcdc3d4e378a967019f512a6ca~mv2.png/v1/fill/w_170,h_49,al_c,q_85,usm_0.66_1.00_0.01/PlayStore-BTN_02.webp">
             </a>
          </mat-card-actions>
        </mat-card> -->
    </div>
</div>
